import { NumberOfEmployees } from "@/common/types/enum";

export const options = {
    number_of_employees: {
        [NumberOfEmployees["0_20"]]: "0 a 20 funcionários",
        [NumberOfEmployees["21_50"]]: "21 a 50 funcionários",
        [NumberOfEmployees["51_100"]]: "51 a 100 funcionários",
        [NumberOfEmployees["101_500"]]: "101 a 500 funcionários",
        [NumberOfEmployees["501_1000"]]: "501 a 1000 funcionários",
        [NumberOfEmployees["1001_5000"]]: "1001 a 5000 funcionários",
        [NumberOfEmployees["5001_MORE"]]: "5001 ou mais funcionários",
    },
};
